import styles from './PageInfo.module.css'
import HeaderLogin from '../../Components/HeaderLogin'
import Header from '../../Components/Header'
import Footer from '../../Components/Footer'
import Loader from '../../Components/Loader'
import imageContentSoon from './../../imgs/bgPageContentSoon.png'
import { useContext, useEffect } from 'react'
import { DataContext } from '../../Components/DataContext'
import { useOutletContext } from 'react-router-dom'

function PageInfo() {

  const { loading } = useContext(DataContext)  
  const { loginValidate, setActivePageMulti, setActivePageMain, setActivePageDemo, setActivePageThreeMulti, setActivePageFormsQuestionsOptions, 
    setActivePageInfo, setActivePageQuizBuilder } = useOutletContext()

  useEffect(() => {
    // tornar a página ativa ao entrar na rota dela e desativa as demais
    setActivePageInfo(true)

    setActivePageDemo(false)
    setActivePageMain(false)
    setActivePageMulti(false)
    setActivePageThreeMulti(false)
    setActivePageFormsQuestionsOptions(false)
    setActivePageQuizBuilder(false)

  }, [setActivePageInfo, setActivePageDemo, setActivePageMain, setActivePageMulti, setActivePageThreeMulti, setActivePageFormsQuestionsOptions, setActivePageQuizBuilder])

  return (
    <div className={styles.pageInfo}>
      {!loginValidate && 
        <>
          <HeaderLogin />
          <main className={styles.bgLogin}></main>

        </>
      }

      {loginValidate && 
        <>
          <Header />

          <main className={styles.mainPageInfo}>
            <h1 className={styles.titlePage}>Info</h1>

            <img 
              className={styles.imageContentSoon}
              src={imageContentSoon} 
              alt='img content soon' 
            />
          </main>
        
        </>
      }

      <Footer />           
            
      {loading && <Loader />}

    </div>
  )

}

export default PageInfo
